import { baseDeleteQuery } from '../../../../utility/sb-api/sb-api.service';

export const removeInfo = (id, storeId, onSuccessCallback) => {
  baseDeleteQuery(
    `manager/stores/${storeId}/menu-entries/info/${id}`,
    null,
    'removeItemSuccess',
    'removeItemError',
  ).then(() => onSuccessCallback());
};
